<template>
  <Collapse simple class="collapse-warpper" value="1">
    <Panel name="1" class="collapse-panel">
      <span class="panel-title">{{initdata.title}}</span>
      <div slot="content">
        <!-- 单选框组 on-change 类似于watch-->
        <RadioGroup v-if="initdata.selectedIndex != undefined || initdata.selectedIndex != 'undefined'" v-model="initdata.selectedIndex" @on-change="areaChange" style="width: 100%;">
          <drop
            class="sort-item"
            v-for="(item,index) in initdata.dataList"
            :data-index="index"
            :key="item.label"
            @eldrop="eldrop"
            :el-index="index"
          >
            <!-- 单选框 -->
            <Radio :label="index" class="sort-checkbox">
              <span class="sort-label">{{item.label}}</span>
            </Radio>
            <!-- 复选框人数 -->
            <span v-if="$route.name != 'userCitizen'" class="sort-number">{{item.number}}</span>
          </drop>
        </RadioGroup>
      </div>
    </Panel>
  </Collapse>
</template>

<script>
import drop from "../dragger/drop";
export default {
  props: ["initdata", "filterListIndex", "debounceTime"],
  created() {
    this.dataList = 0
    this.areaChange = this._.debounce(this._areaChange, this.debounceTime, false);
  },
  mounted() {
  },
  data() {
    return {
      dataList: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    /* 单选组勾选装填改变 */
    _areaChange(e) {
      this.$emit("event", {
        fn: "areaChange",
        params: {
          selectedIndex: this.initdata.selectedIndex || this.dataList, // 如果第一个值为 0 则返回二者没有区别
          filterListIndex: this.filterListIndex
        }
      });
    },
    eldrop(e) {
      this.$emit("event", {
        fn: "orgDrop",
        params: {
          filterListIndex: this.filterListIndex,
          ...e
        }
      });
    },
    reset() {
      this.dataList = 0;
      this.select_value = this.initdata.dataList[0].label;
      this.$emit("event", {
        fn: "reset"
      });
    }
  },
  components: {
    drop
  },
  destroyed() {}
};
</script>
<style scoped lang="less">
@import "./collapse.less";
</style>
